import { Injectable, signal } from '@angular/core';

/**
 * Lets a page component append a dynamic suffix to the app header's title without the header
 * needing to know about any specific route's data. The header just concatenates `${base}
 * ${suffix}`, so the suffix must carry its own leading separator/prefix text (e.g. "von
 * <tempCustomer>" or "- <orderId>"). Pages set the suffix once they have the relevant value and
 * must clear it in ngOnDestroy so it never leaks into another page's title.
 */
@Injectable({ providedIn: 'root' })
export class PageTitleService {
  public readonly suffix = signal<string | null>(null);

  public setSuffix(value: string | null | undefined): void {
    this.suffix.set(value || null);
  }

  public clear(): void {
    this.suffix.set(null);
  }
}
